import { Text } from '@soteria/design-system-ve';

import * as styles from '../CommunityAuditAccuracyChart.css';

/**
 * Chart header component displaying only the title
 * (percentage removed since it's shown in Production Status panel)
 */
export function ChartHeader() {
  return (
    <Text className={styles.title} size="base" weight="medium">
      Audit Performance Over Time
    </Text>
  );
}
